import { combineReducers } from 'redux';
import { favorites } from './favorites';

export const reducers = combineReducers({
    favorites
})